"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderTransformer = exports.RowTransformerValidator = void 0;
var RowTransformerValidator_1 = require("./RowTransformerValidator");
Object.defineProperty(exports, "RowTransformerValidator", {
  enumerable: true,
  get: function get() {
    return RowTransformerValidator_1.RowTransformerValidator;
  }
});
var HeaderTransformer_1 = require("./HeaderTransformer");
Object.defineProperty(exports, "HeaderTransformer", {
  enumerable: true,
  get: function get() {
    return HeaderTransformer_1.HeaderTransformer;
  }
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3RyYW5zZm9ybXMvaW5kZXgudHMiXSwic291cmNlc0NvbnRlbnQiOltudWxsXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBO0FBQVM7RUFBQTtFQUFBO0lBQUEsd0RBQXVCO0VBQUE7QUFBQTtBQUNoQztBQUFTO0VBQUE7RUFBQTtJQUFBLDRDQUFpQjtFQUFBO0FBQUEiLCJpZ25vcmVMaXN0IjpbXX0=